module.exports = __webpack_public_path__ + "static/media/Mioo_Black.0d117023.svg";